/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
import type { FragmentReference } from "relay-runtime";
declare export opaque type NotesWidgetContainer_user$ref: FragmentReference;
declare export opaque type NotesWidgetContainer_user$fragmentType: NotesWidgetContainer_user$ref;
export type NotesWidgetContainer_user = {|
  +id: string,
  +$refType: NotesWidgetContainer_user$ref,
|};
export type NotesWidgetContainer_user$data = NotesWidgetContainer_user;
export type NotesWidgetContainer_user$key = {
  +$data?: NotesWidgetContainer_user$data,
  +$fragmentRefs: NotesWidgetContainer_user$ref,
};
*/


const node/*: ReaderFragment*/ = {
  "kind": "Fragment",
  "name": "NotesWidgetContainer_user",
  "type": "User",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "id",
      "args": null,
      "storageKey": null
    }
  ]
};
// prettier-ignore
(node/*: any*/).hash = 'ffa584151975cac7a92e5c62231e6b1b';
module.exports = node;
